<div class="main-content">
  <div class="main-heading">
    <span translate>NEW_USER</span>
  </div>
  <div class="card">
    <div class="card-body">
      <form
        [formGroup]="adminUserAddForm"
        (submit)="saveChanges()"
        class="form"
      >
        <adminuser-form (validChange)="onValidChange($event)" [adminUserForm]="adminUserAddForm"></adminuser-form>
        <div *ngIf="usernameWarning === 'deleted'" class="alert alert-info mb-2">
          <span translate>USERNAME_DELETED_INFO</span>
        </div>
        <div *ngIf="usernameWarning === 'inactive'" class="alert alert-warning mb-2">
          <span translate>USERNAME_INACTIVE_WARN</span>
        </div>
        <div class="action-btns-wrapper text-left">
          <a
            class="btn btn-outline-secondary"
            [routerLink]="['./../list']"
            role="button"
          >
            <i class="pi pi-arrow-left"></i>
            <span translate>BACK_LIST</span>
          </a>
          <button
            class="btn btn-primary"
            type="submit"
            [disabled]="!adminUserAddForm.valid || !isPasswordValid"
          >
            <span translate>SAVE_CHANGES</span>
          </button>
         
        </div>
      </form>
    </div>
  </div>
</div>
